import { render } from "./TheButtons.vue?vue&type=template&id=64444a01"
import script from "./TheButtons.vue?vue&type=script&lang=js"
export * from "./TheButtons.vue?vue&type=script&lang=js"

import "./TheButtons.vue?vue&type=style&index=0&id=64444a01&lang=scss"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__